import toast from "react-hot-toast";

/**
 * Utility function to display toast notifications with consistent styling and behavior
 *
 * @param {string} message - The message to display in the toast
 * @param {string} type - The type of toast: 'success', 'error', 'info', 'warning'
 * @param {string} id - Optional custom ID for the toast to prevent duplicates
 */
const showToast = (message, type, id = null) => {
	// Generate component-specific ID if none provided
	const toastId =
		id || `toast-${Date.now()}`;

	const options = {
		id: toastId,
		duration: 5000,
		position: "top-right",
	};

	switch (type) {
		case "success":
			return toast.success(message, options);
		case "error":
			return toast.error(message, options);
		default:
			return toast(message, options);
	}
};

export default showToast;
